import { createStore } from 'vuex'

export default createStore({
  state: {
    email: localStorage.getItem("stichh_user_email") || "",
  },
  getters: {
    getEmail: (state) => state.email,
  },
  mutations: {
    setEmail(state, email) {
      state.email = email || "";
      localStorage.setItem("stichh_user_email", state.email);
    },
  },
  actions: {
  },
  modules: {
  }
})
